import { ModalsStore } from '@/utils/store/modalsStore/modalsStore';
import { UserStore } from '@/utils/store/userStore/userStore';
import { SystemStore } from '@/utils/store/systemStore/systemStore';

const systemStore = new SystemStore();
const modalsStore = new ModalsStore();
const userStore = new UserStore();

export const RootStore = {
    systemStore,
    modalsStore,
    userStore,
};
